export default __webpack_public_path__ + "static/media/220.af32df13.png";